import CountryCodeList from '../config/countryCode.json';
const getNameFromSettings = (data,category,id)=>{
    let item = data[category].find((item,index)=>item.id === id)
    return item ? item.name : [];
}

const getDialCodeFromSettings = (dial_code)=>{
    let item = CountryCodeList.find((item,index)=>item.dial_code === dial_code)
    return item ? item.dial_code : '';
}
const getCountryFromSettings = (id)=>{
    let item = CountryCodeList.find((item,index)=>item.id === id)
    return item ? item.name : '';
}

const getCountryFromCodeSettings = (code)=>{
    let item = CountryCodeList.find((item,index)=>item.code === code)
    return item ? item.name : '';
}
const getListFromSettings = (data,category)=>{
    return data[category];
    // data.filter(obj => {
    //     return obj.category === category
    //   })
}
const getMonth = (monthNumber)=>
{
    const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
    return monthNames[monthNumber]
}

const getTime = (timestamp)=>
{
    var shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var startTime = new Date(timestamp );
    var hour = startTime.getHours();
    var miniutes = startTime.getMinutes()
    if(startTime.getHours() < 10){
        hour = '0' + startTime.getHours();
    }if(startTime.getMinutes() < 10){
        miniutes = '0' + startTime.getMinutes();
    }
    return `${shortMonths[startTime.getMonth()]} ${startTime.getDate()}, ${startTime.getFullYear()} - ${hour}:${miniutes}`
}

async function dataURItoBlob(url){
    return await (await fetch(url)).blob()
}

function isNonZero(value) {
    const number = Number(value);
    return number !== 0 && !isNaN(number);
  }

export {getListFromSettings,getNameFromSettings,dataURItoBlob,getDialCodeFromSettings,getCountryFromSettings,getTime,getCountryFromCodeSettings, isNonZero}